import { render, staticRenderFns } from "./formAddTask.vue?vue&type=template&id=6683a6e2&"
import script from "./formAddTask.vue?vue&type=script&lang=js&"
export * from "./formAddTask.vue?vue&type=script&lang=js&"
import style0 from "./formAddTask.vue?vue&type=style&index=0&id=6683a6e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports